/**
*@title
*@date 2022-02-07, 2022-07
*@athour 홍수희
*@developer 박지훈, 권윤성
*@desc
*@etc(change)
*/

import React from 'react';
import { useTranslation } from "react-i18next";

import { Link } from "react-router-dom"

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

import MouseScroll from "../../Components/Scroll/MouseScroll";

import './MainLogo.css?ver=1';

import whale_icon from '../../images_mainlogo/whale_main_logo.svg';
import whale_gray_icon from '../../images_mainlogo/whale_main_logo.svg';
import whale_purple_icon from '../../images_mainlogo/whale_main_logo_purple.svg';
import expo_logo_en from '../../images_mainlogo/expo_logo_white.png';
import expo_logo_kr from '../../images_mainlogo/expo_logo_white_kor.png';

const MainLogo = () => {
    const { t } = useTranslation();

    return(
        <div>
            <div className='main-container'>
                {/* <div className='main-top-deco-img-wrap absolute'>
                    <div className='main-top-deco-img-box'>
                        <img src={honeycomb}/>
                    </div>
                </div> */}
                {/* <div className='main-top-deco-img-wrap absolute'>
                    <div className='main-top-deco-img-box'>
                        <img class="limitwidth" src={sparkle}/>
                    </div>
                </div> */}
                <div className='img-whale-container'>
                        <img class="img-whale" src={whale_icon} style={{maxHeight:"300px"}}/>
                </div>
                    <div className='main-logo-container'>
                        <ul>
                            <li>
                                {
                                    t("lang") === "ko"
                                    ?<img class="top inline py-0 w-10/12 md:w-3/5" src={expo_logo_kr}/>
                                    :<img class="top inline py-0 w-10/12 md:w-3/5" src={expo_logo_en}/>
                                }
                                
                            </li>
                            <li>
                                {
                                    t("lang") === "ko"
                                    ?<img class="bottom inline w-6/12 md:w-2/5" src={expo_logo_en}/>
                                    :<img class="bottom inline w-6/12 md:w-2/5" src={expo_logo_kr}/>
                                }
                                
                            </li>
                        </ul>
                    </div>
                    <div className='main-top-txt-wrap text-white sm:text-base md:text-2xl lg:text-4xl pt-16 font-bold'>
                            {t("mainlogo_date")}<br/>{t("mainlogo_place")}
                    </div>
                        <div className='main-top-cont-btn-box'>
                            <div className='main-top-cont-btn-wrap text-sm md:text-base lg:text-lg'>
                            {/* {window.innerWidth} */}
                            <Link to="/visitor/registration" className='main-top-cont-btn-link main-top-cont-btn-link-marginRight'>
                                <div className="main-top-cont-btn btn-color" style={{padding:"5px"}}>
                                            {t("mainlogo_preregi")}
                                </div> 
                            </Link>
                            <Link to="/exhibitor/overview" className='main-top-cont-btn-link'>
                                <div className="main-top-cont-btn btn-color"  style={{padding:"5px"}}>
                                            {t("mainlogo_com_preregi")}
                                </div> 
                            </Link>
                            </div>
                            
                        </div>
                    <MouseScroll />
                    {/* <div class="main-top-deco-whale">
                        <img src={whale_icon}/>
                    </div> */}
            </div>
        </div>
        // <div className="top-section-wrap">
        //     <div className="main-visual">
        //         <div className="top-cont-sect">
        //             <div className="top-cont-txt-box">
        //                 <div className="top-cont-btn"><a href="">{t("mainlogo_preregi")} <br/> {t("mainlogo_preregi_ready")}</a></div>
        //                 <p className="top-cont-txt-02">D - {result}</p>
        //                 <p className="top-cont-txt-01">{t("mainlogo_date")}<br/>{t("mainlogo_place")}</p>
        //             </div>
        //         </div>
        //     </div>
        //     <div id="menu-01"></div>
        // </div>
    )
}

export default MainLogo;